require('./cardShowAndHideSensitiveInformation.scss');

const PropTypes = require('prop-types');

const React = require('react');
const CardShowAndHideSensitiveInformationExpired = require('./cardShowAndHideSensitiveInformationExpired');
const CardShowAndHideSensitiveInformationNonExpired = require('./cardShowAndHideSensitiveInformationNonExpired');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const {EXPIRATION_CODE_TIME} = require('constants/index');

class CardShowAndHideSensitiveInformation extends React.Component {

    constructor(props) {
        super(props);

        this.expiredCode = this.expiredCode.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        if (this.props.codeNumber) {
            this.expirationTimeout = setTimeout(this.expiredCode, EXPIRATION_CODE_TIME);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.expirationTimeout);
    }

    expiredCode() {
        this.props.setExpired(this.props.cardId);
    }

    render() {
        const { textBack, reset, codeNumber, title, cardId, messageExpired, messageNonExpired, messageShortNonExpired, isPin } = this.props;
        let bodyContent;

        if (!!codeNumber) {
            bodyContent = (
                <CardShowAndHideSensitiveInformationNonExpired
                    title={title}
                    codeNumber={codeNumber}
                    cardId={cardId}
                    messageNonExpired={messageNonExpired}
                    messageShortNonExpired={messageShortNonExpired}
                    textBack={textBack}
                    isPin={isPin}
                />
            );
        } else {
            bodyContent = (
                <CardShowAndHideSensitiveInformationExpired
                    title={title}
                    cardId={cardId}
                    messageExpired={messageExpired}
                    textBack={textBack}
                    triggerNewRequest={reset}
                />
            )
        }
        return (
            <section className="code-confirmation-success">
                {bodyContent}
            </section>
        );
    }
}

CardShowAndHideSensitiveInformation.propTypes = {
    cardId: PropTypes.string.isRequired,
    codeNumber: PropTypes.string,
    setExpired: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    messageExpired: PropTypes.string.isRequired,
    messageNonExpired: PropTypes.string.isRequired,
    messageShortNonExpired: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    textBack: PropTypes.string.isRequired,
    isPin: PropTypes.bool.isRequired
};

module.exports = CardShowAndHideSensitiveInformation;